import { render } from "./LinkBtn.vue?vue&type=template&id=38d9aa5e&scoped=true"
import script from "./LinkBtn.vue?vue&type=script&lang=js"
export * from "./LinkBtn.vue?vue&type=script&lang=js"

import "./LinkBtn.vue?vue&type=style&index=0&id=38d9aa5e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-38d9aa5e"

export default script